module.exports = __webpack_public_path__ + "static/media/TonoDaruma_06B_01.70e32675.png";